module.exports = __webpack_public_path__ + "img/hero-ai.ce997fa1.jpg";